/**
 * SkillDelivery Platform
 *
 * Copyright © 2025-2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 *
 * SkillBot Page - Full-page dedicated SkillBot interface
 * Phase 0.8 P7e: Unified with floating bubble by reusing SkillBotEnhanced component
 *
 * This page renders SkillBotEnhanced in fullPage mode, ensuring identical
 * styling and functionality between the floating bubble and full-page versions.
 */

import React from 'react';
import SkillBotEnhanced from '../components/SkillBotEnhanced';

const SkillBotPage = () => {
  return (
    <div className="h-screen bg-gray-100">
      <SkillBotEnhanced fullPage={true} />
    </div>
  );
};

export default SkillBotPage;
